import React from 'react';

import { H1, H2, H3, H4, H5, H6 } from '../Primitives/Heading';

const TITLE_COMPONENTS = {
  heading1: H1,
  heading2: H2,
  heading3: H3,
  heading4: H4,
  heading5: H5,
  heading6: H6,
};

/**
 * Console heading fields are a single string. Convert markdown **bold**
 * (and existing <strong> HTML) into React <strong> nodes.
 *
 * @param {string} content
 * @returns {string|Array<string|JSX.Element>}
 */
const renderInlineStrong = content => {
  if (typeof content !== 'string') {
    return content;
  }

  const tokens = content.split(/(\*\*[^*]+\*\*|<strong>[\s\S]*?<\/strong>)/gi);
  if (tokens.length === 1) {
    return content;
  }

  return tokens.map((token, index) => {
    const markdownBold = token.match(/^\*\*([^*]+)\*\*$/);
    if (markdownBold) {
      return <strong key={`strong-${index}`}>{markdownBold[1]}</strong>;
    }
    const htmlBold = token.match(/^<strong>([\s\S]*?)<\/strong>$/i);
    if (htmlBold) {
      return <strong key={`strong-${index}`}>{htmlBold[1]}</strong>;
    }
    return token;
  });
};

/**
 * Render a Console title field with inline **bold** as <strong>.
 *
 * @component
 * @param {Object} props
 * @param {Object?} props.data
 * @param {string?} props.className
 * @returns {JSX.Element|null}
 */
const SectionTitle = props => {
  const { data, className } = props;
  if (typeof data?.content !== 'string' || data.content.length === 0) {
    return null;
  }
  const Component = TITLE_COMPONENTS[data.fieldType] || H2;
  return <Component className={className}>{renderInlineStrong(data.content)}</Component>;
};

export default SectionTitle;
